module.exports = "<hot-table [minSpareRows]=\"0\" [height]=\"600\" [manualColumnResize]=\"true\" [autoColumnSize]=\"true\" [startRows]=\"35\" [height]=\"600\" [rowHeaders]=\"rowHeaders\" [columns]=\"columns\" [data]=\"data\" hotId=\"WBSAllocationComponents\">\n</hot-table>"


//////////////////
// WEBPACK FOOTER
// ./src/app/wbs-allocation-components/wbs-allocation-components.component.html
// module id = ./src/app/wbs-allocation-components/wbs-allocation-components.component.html
// module chunks = main